module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-unactive-fb26733e.png";